// extracted by mini-css-extract-plugin
export var calendarContainer = "giveinput-module--calendar-container--NuXmF";
export var container = "giveinput-module--container--w2cGx";
export var highlight = "giveinput-module--highlight--biuHI";
export var personContainer = "giveinput-module--person-container--AfDcQ";
export var subhed = "giveinput-module--subhed--CON9s";
export var text = "giveinput-module--text--9CGuj";